import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { DashboardComponent } from '@app/dashboard/dashboard.component';
import { SharedModule } from '@app/shared/shared.module';
import { OpentasksComponent } from './opentasks/opentasks.component';
import { CompletedTasksComponent } from './completedtasks/completedtasks.component';
import { TasksService } from './shared/services/tasks.service';
import { OfflinetrainingComponent } from './shared/components/offlinetraining/offlinetraining.component';
import { DocumentComponent } from './shared/components/document/document.component';
import { SafetyVideoComponent } from './shared/components/safetyvideo/safetyvideo.component';
import { FileManagementService } from '../shared/services/file-management.service';
import { OfflineDocsComponent } from './shared/components/offlinetraining/completed/offlinedocs.component';
import { CertificateService } from './shared/services/certificate.service';
import { ResourceService } from './shared/services/resource.service';
import { AuditsService } from './shared/services/audits.service';
import { LinkComponent } from './shared/components/link/link.component';

@NgModule({
	declarations: [
		DashboardComponent,
		OpentasksComponent,
		CompletedTasksComponent,
		OfflinetrainingComponent,
		DocumentComponent,
		SafetyVideoComponent,
		OfflineDocsComponent,
		LinkComponent,
	],
	imports: [SharedModule, CommonModule],
	exports: [],
	providers: [TasksService, CertificateService, DatePipe, ResourceService, AuditsService],
})
export class DashboardModule {}
